import { render, staticRenderFns } from "./InfoPagesTab.vue?vue&type=template&id=81f155fa&scoped=true"
import script from "./InfoPagesTab.vue?vue&type=script&lang=js"
export * from "./InfoPagesTab.vue?vue&type=script&lang=js"
import style0 from "./InfoPagesTab.vue?vue&type=style&index=0&id=81f155fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f155fa",
  null
  
)

export default component.exports